/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectPlanPriority = {
    Low: 0,
    Medium: 1,
    High: 2
} as const;

export type ProjectPlanPriority = typeof ProjectPlanPriority[keyof typeof ProjectPlanPriority];



